import { createSelector } from '@reduxjs/toolkit';
import { SettingsState } from 'ducks/settings/slices';
import { RootState } from 'store';

const settingsSlice = (state: RootState) => state.settings;

export const selectSettings = createSelector([settingsSlice], (state): SettingsState => state);
export const selectSettingsError = createSelector([settingsSlice], (state): SettingsState['error'] => state.error);
